import {IconButton} from '@wandb/components';
import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

import {TaskState} from '../../generated/graphql';
import {
  Banner,
  BannerBoldText,
  BannerFlexWrapper,
  BannerTextWrapper,
} from '../Banner';

type HistoryMaterializationBannerProps = {
  task: {state: TaskState; type?: string} | null | undefined;
  onDismiss: () => void;
};

export const HistoryMaterializationBanner = ({
  task,
  onDismiss,
}: HistoryMaterializationBannerProps) => {
  // Show nothing if no task or task is finished
  if (!task || task.state === TaskState.Finished) {
    return null;
  }

  const isRewind = task.type === 'rewind_run';
  const operation = isRewind ? 'Rewinding' : 'Forking';
  const noun = isRewind ? 'rewind' : 'fork';

  // Show error banner if task failed
  if (task.state === TaskState.Failed) {
    return (
      <div className="px-16 pt-8">
        <Banner variant="warning">
          <BannerFlexWrapper className="w-full">
            <BannerTextWrapper className="flex-1">
              <Icon name="warning" className="inline-block mr-4" />
              <BannerBoldText>{operation} failed.</BannerBoldText>
              There was an error rebuilding the history for this{' '}
              {isRewind ? 'rewound' : 'forked'} run. Please try again or contact
              support.
            </BannerTextWrapper>
            <IconButton
              icon="close"
              variant="ghost"
              size="sm"
              aria-label="Dismiss banner"
              onPress={onDismiss}
            />
          </BannerFlexWrapper>
        </Banner>
      </div>
    );
  }

  return (
    <div className="px-16 pt-8">
      <Banner variant="info">
        <BannerFlexWrapper className="w-full">
          <BannerTextWrapper className="flex-1">
            <Icon name="lightbulb-info" className="inline-block mr-4" />
            <BannerBoldText>{operation} in progress.</BannerBoldText>
            Recent metrics and summary values may be incomplete while we finish
            rebuilding this {noun}.
          </BannerTextWrapper>
          <IconButton
            icon="close"
            variant="ghost"
            size="sm"
            aria-label="Dismiss banner"
            onPress={onDismiss}
          />
        </BannerFlexWrapper>
      </Banner>
    </div>
  );
};
